import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink, WA_MESSAGES } from "../lib/whatsapp";

const MobileCta = () => (
  <motion.div
    initial={{ y: 90 }}
    animate={{ y: 0 }}
    transition={{ duration: 0.8, delay: 1.4, ease: [0.16, 1, 0.3, 1] }}
    className="fixed inset-x-0 bottom-0 z-50 p-4 md:hidden"
  >
    <a
      href={waLink(WA_MESSAGES.general)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="mobile-whatsapp-cta"
      className="flex w-full items-center justify-center gap-2.5 rounded-full bg-wa py-4 font-display text-sm font-bold text-ink shadow-[0_10px_40px_rgba(37,211,102,0.35)] active:scale-95"
    >
      <MessageCircle className="h-5 w-5" strokeWidth={2.4} />
      Falar no WhatsApp
    </a>
  </motion.div>
);

export default MobileCta;
